import { render } from "./App.vue?vue&type=template&id=3ba39ce5&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3ba39ce5&lang=css"

import exportComponent from "/Users/kosugi/Dev/IdeaProjects/v4/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__